<template>
  <div class="contact">
    <v-container class="py-12 container-rewrite">
      <v-row>
        <v-col cols="12" sm="6" md="3">
          <div>
            <span class="d-block">
              <span class="gtAmerica-bold">Reach us by email</span>
              <br />
              <a href="mailto:info@artlesscorporation.com" class="not-text-decoration color-black">info@artlesscorporation.com</a>
            </span>

            <span class="d-block mt-5">
              <span class="gtAmerica-bold">Reach us by phone</span>
              <br />
              <a href="tel:3105620916" class="not-text-decoration color-black">310-562-0916</a>
            </span>

            <div class="mt-5 width-fit-content">
              <router-link to="/" class="not-text-decoration">
                <span class="link-worshop gtAmerica-bold">
                  Visit the workshop
                  <div class="animation-line"></div>
                </span>
              </router-link>
            </div>

            <!-- <span class="d-block mt-5 national-regular">Visit the workshop</span> -->
          </div>

          <div class="margin-div-custom">
            <!-- <a
              href="https://www.google.com/maps/place/2830+Glenoaks+Canyon+Dr,+Glendale,+CA+91206,+EE.+UU./data=!4m2!3m1!1s0x80c2c3d718be1d05:0x6d174c37298049b1?sa=X&ved=2ahUKEwiU--Tdt8vrAhURW60KHYAqAXsQ8gEwAHoECAsQAQ"
              target="_blank"
              class="not-text-decoration"
            >
              <span class="d-block">
                <span class="gtAmerica-bold">ARTLESS Office</span>
                <br />2830 Glenoaks Canyon Dr
                <br />Glendale CA 91206
              </span>
            </a> -->

            <a
              href="https://www.google.com/maps/place/3011+N+Main+St,+Los+Angeles,+CA+90031,+EE.+UU./@34.0662713,-118.2119496,17z/data=!3m1!4b1!4m5!3m4!1s0x80c2c679d904c3c5:0xa81f5494d34780e5!8m2!3d34.0662713!4d-118.2097609?shorturl=1"
              target="_blank"
              class="not-text-decoration"
            >
              <span class="d-block mt-5">
                <span class="gtAmerica-bold">ARTLESS</span>
                <br />3011 N Main Street
                <br />Los Angeles, CA 90031
              </span>
            </a>
          </div>

          <div class="mt-10 margin-div-mobile">
            <div
              v-for="(network, nt) in socialNetworks"
              :key="nt"
              class="d-inline-block social-separation"
            >
              <template v-if="width >= 2300">
                <template v-if="width >= 3500">
                  <a :href="network.link" target="_blank">
                    <v-img :src="network.image" width="75"></v-img>
                  </a>
                </template>
                <template v-else>  
                  <a :href="network.link" target="_blank">
                    <v-img :src="network.image" width="50"></v-img>
                  </a>
                </template>
              </template>
              <template v-else>
                <a :href="network.link" target="_blank">
                  <v-img :src="network.image"></v-img>
                </a>
              </template>
            </div>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="3" class="z-index-2rd-column">
          <div>
            <span class="d-block">
              <span class="d-block gtAmerica-bold">FOUNDER</span>
              <span class>
                Alejandro Artigas
                <a
                  href="mailto:artigas@artlesscorporation.com"
                  class="d-block not-text-decoration color-black"
                >artigas@artlesscorporation.com</a>
                <a href="tel:310-666-7529" class="d-block not-text-decoration color-black">310-666-7529</a>
              </span>
            </span>

            <span class="d-block mt-10">
              <span class="d-block gtAmerica-bold">PRODUCTION</span>
              <span class>
                Santiago Manon
                <a
                  href="mailto:santiago@artlesscorporation.com"
                  class="d-block not-text-decoration color-black"
                >santiago@artlesscorporation.com</a>
                <a href="tel:619-252-9914" class="d-block not-text-decoration color-black">619-252-9914</a>
              </span>
            </span>

            <span class="d-block mt-10">
              <span class="d-block gtAmerica-bold">SALES DIRECTOR</span>
              <span class>
                Melissa Ritchie
                <a
                  href="mailto:melissa.ritchie@artlesscorporation.com"
                  class="d-block not-text-decoration color-black"
                >melissa.ritchie@artlesscorporation.com</a>
                <a href="tel:323-646-2917" class="d-block not-text-decoration color-black">323-646-2917</a>
              </span>
            </span>

            <span class="d-block mt-10">
              <span class="d-block gtAmerica-bold">DESIGN ASSOCIATE</span>
              <span class>
                Evelyn Sanchez
                <a
                  href="mailto:evelyn@artlesscorporation.com"
                  class="d-block not-text-decoration color-black"
                >evelyn@artlesscorporation.com</a>
              </span>
            </span>

            <span class="d-block mt-10">
              <span class="d-block gtAmerica-bold">WEB INTEGRATION</span>
              <span class>
                Alex Bajos
                <a
                  href="mailto:bajos@artlesscorporation.com"
                  class="d-block not-text-decoration color-black"
                >bajos@artlesscorporation.com</a>
              </span>
            </span>

            <span class="d-block mt-10">
              <span class="d-block gtAmerica-bold">LOGISTICS</span>
              <span class>
                Christian Rodriguez
                <a
                  href="mailto:christian@artlesscorporation.com"
                  class="d-block not-text-decoration color-black"
                >christian@artlesscorporation.com</a>
              </span>
            </span>

            <span class="d-block mt-10">
              <span class="d-block gtAmerica-bold">PHOTOGRAPHY</span>
              <span class>
                Melissa Keller
                <a
                  href="mailto:melissa@artlesscorporation.com"
                  class="d-block not-text-decoration color-black"
                >melissa@artlesscorporation.com</a>
              </span>
            </span>
          </div>
        </v-col>

        <v-col cols="12" sm="12" md="6" class="z-index-3rd-column">
          <v-img src="@/assets/img/photos/Artlles-profile-about.jpg" class="contact-image"></v-img>

          <div class="text-center pt-7">
            <span class="d-block title-contact">ARTLESS is after the timeless</span>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>

import instagram from "@/assets/img/icons/instagram.svg";

import pinterest from "@/assets/img/icons/pinterest.svg";

export default {
  data() {
    return {
      socialNetworks: [
        
        {
          link: "https://www.instagram.com/artlesscorporation/",
          image: instagram,
        },
        {
          link: "https://www.pinterest.com.mx/artlesscorp/_created/",
          image: pinterest,
        },
      ],
    };
  },
  computed:{
    width:function(){
      console.log(this.$vuetify)
      return this.$vuetify.breakpoint.width;
    }
  },
  mounted: function(){
    var breadcrumbs = [
        {
            text: 'Home',
            link: '/',
            isLink: true
        },
        {
            text: 'Contact',
            link: '/contact',
            isLink: false
        }
    ];
    this.$emit("updateStatus", breadcrumbs);
    this.$emit("update", 0);
    gtag('config', 'UA-26953667-1', {
      'page_title' : 'Contact',
      'page_path': '/contact'
    });
  }
};
</script>